import { ChildRef } from '../../../../../lib/web/components/child-ref';
import { ClickListener } from '../../../../../lib/web/components/click-listener';
import { Component } from '../../../../../lib/web/components/component';
import { ModalComponent } from '../../../../../lib/web/components/modal.component';
import { ApiService } from '../../../services/api.service';
import { ToggleSelectorComponent } from '../../atoms/toggle-selector/toggle-selector.component';

@Component({
    selector: '.m-manage-disciplines'
})
export class ManageDisciplinesComponent extends ModalComponent<HTMLInputElement> {

    @ChildRef()
    private _disciplineSelector: ToggleSelectorComponent = null;

    private _saving: boolean = false;
    
    public constructor(node: HTMLInputElement, private _apiService: ApiService) {
        super(node);
    }    

    public onInit(): void {
        super.onInit();
        this._disciplineSelector.addCustomEventListener('selection-changed', () => {
            // Mientras hay un guardado en curso el botón debe seguir deshabilitado
            if (!this._saving) {
                this.setSaveDisabled(false);
            }
        });
    }

    public async open(): Promise<boolean> {
        this.setSaveDisabled(true);
        this._disciplineSelector.reset();
        return super.open();
    }

    @ClickListener('.m-manage-disciplines__cancel')
    public onCancel(): void {
        this.close();
    }

    @ClickListener('.m-manage-disciplines__save')
    public async onSave(): Promise<void> {
        if (this._saving) {
            return;
        }
        const selected: number[] = this._disciplineSelector.selected;
        if (selected && selected.length) {
            // Evita que un doble clic lance varias peticiones mientras la primera está en curso
            this._saving = true;
            this.setSaveDisabled(true);
            try {
                await this._apiService.post('/api/v1/user/disciplines', {
                    body: {
                        disciplines: selected
                    }
                });
            }
            catch (e: any) {
                this.showUnexpectedError(e);
                return;
            }
            finally {
                this._saving = false;
                this.setSaveDisabled(false);
            }
        }
        this.close(true);
    }

    private setSaveDisabled(disabled: boolean): void {
        // Se busca dentro del modal para no actuar sobre otra instancia del botón en el documento
        const button: HTMLButtonElement = this.node.querySelector('.m-manage-disciplines__save');
        if (button) {
            button.disabled = disabled;
        }
    }
}